import type { TimelineEvent } from "../data/api-types";
import { mockToday as today } from "./today";

export const mockTimelineEvent: TimelineEvent = {
  id: "te_001",
  customer_id: "cust_048",
  event_type: "call",
  title: "Quarterly review call",
  description: "Walked through Q1 performance and upcoming projects.",
  event_at: `${today}T10:30:00Z`,
  created_at: `${today}T10:35:00Z`,
  source_system: "manual",
  source_entity_id: null,
  source_entity_type: null,
};

export const mockTimelineEvents: TimelineEvent[] = [
  mockTimelineEvent,
  {
    id: "te_002",
    customer_id: "cust_022",
    event_type: "email",
    title: "Followed up on quote",
    description: "Sent revised pricing for Q2.",
    event_at: `${today}T14:00:00Z`,
    created_at: `${today}T14:01:00Z`,
    source_system: "manual",
    source_entity_id: null,
    source_entity_type: null,
  },
  {
    id: "te_003",
    customer_id: "cust_012",
    event_type: "in-person meeting",
    title: "Onsite review",
    description: "Visited Bramley & Co for production walkthrough.",
    event_at: `${today}T11:00:00Z`,
    created_at: `${today}T17:00:00Z`,
    source_system: "manual",
    source_entity_id: null,
    source_entity_type: null,
  },
];
